import axios from '@/plugins/axiosPlugin'

export default {
  state: {
    gewerke: [],
    gewerkeLoading: false,
    gewerk: [],
    gewerkLoading: false,
  },

  mutations: {
    setGewerke(state, gewerke) {
      state.gewerke = gewerke
    },
    setGewerkeLoading(state, gewerkeLoading) {
      state.gewerkeLoading = gewerkeLoading
    },
    setGewerk(state, gewerk) {
      state.gewerk = gewerk
    },
    setGewerkLoading(state, gewerkLoading) {
      state.gewerkLoading = gewerkLoading
    },
  },

  actions: {
    getAllGewerke(context) {
      context.commit('setGewerkeLoading', true)
      axios
        .get('lagerverwaltung/gewerk')
        .then((response) => context.commit('setGewerke', response.data.data))
        .catch((e) => { console.log("Error: " + e) })
        .finally(() => context.commit('setGewerkeLoading', false))
    },
    getGewerk(context, gewerkID) {
      context.commit('setGewerkLoading', true)
      axios
        .get('lagerverwaltung/gewerk/' + gewerkID)
        .then((response) => context.commit('setGewerk', response.data.data))
        .catch((e) => { console.log("Error: " + e) })
        .finally(() => context.commit('setGewerkLoading', false))
    },
    registerGewerkPromise(context, gewerk) {
      return axios.put('lagerverwaltung/gewerk', gewerk)
    },
    editGewerkPromise(context, gewerk) {
      return axios.post('lagerverwaltung/gewerk/' + gewerk.ID, gewerk)
    },
    deleteGewerkPromise(context, gewerkID) {
      return axios.delete('lagerverwaltung/gewerk/' + gewerkID)
    },
    getGewerkPromise(context, gewerkID) {
      return axios.get('lagerverwaltung/gewerk/' + gewerkID)
    },
  }
}
